import $ from 'jquery'
import _ from 'underscore'
import messageResource from '../../../../../messageResource'
import PageOverlayTipsManager from '../../../../../tips/PageOverlayTipsManager'
import NumberFormatter from '../../../../../number_formatter'
import StringTokenizer from '../../../../../util/StringTokenizer'
import EmptyHighlighter from '../../../../../util/EmptyHighlighter'
import TokensHighlighter from '../../../../../util/TokensHighlighter'
import WarningsController from '../../../WarningsController'

import Table from '../../../../../table/Table'
import TableCell from '../../../../../table/TableCell'
import UserTableRow from '../UserTableRow'
import UserRowRenderer from '../UserRowRenderer'
import UserTableRenderer from '../UserTableRenderer'
import EditableCell from '../EditableCell'

import {connect} from '../../../../../redux/utils'
import {isPTOTabAvailable, isSDBTabAvailable} from './selectors'
import {isURAEnabled, isBTYEnabled, isTTAEnabled} from '../../../../../features/selectors.js'
import UserNameCell from '../UserNameCell'
import {PlannedPTOLeaveRenderer, PlannedSickLeaveRenderer} from '../PlannedLeaveRenderer'
import ShowPtoHistoryCellRenderer from '../ShowPtoHistoryCellRenderer'
import ShowSickDaysHistoryCellRenderer from '../ShowSickDaysHistoryCellRenderer'
import PtoResetRulesCell from '../PtoResetRulesCell'
import PtoAccrualRulesCell from '../PtoAccrualRulesCell'
import SickDaysResetRulesCell from '../SickDaysResetRulesCell'
import PtoCapRulesCell from '../PtoCapRulesCell'
import SickDaysAccrualRulesCell from '../SickDaysAccrualRulesCell'
import PtoDefaultRulesCell from '../PtoDefaultRulesCell'
import SickDaysCapRulesCell from '../SickDaysCapRulesCell'
import SickDaysDefaultRulesCell from '../SickDaysDefaultRulesCell'
import SickDaysControlRenderer from '../SickDaysControlRenderer'
import PtoControlRenderer from '../PtoControlRenderer'
import SickDaysCellRenderer from '../SickDaysCellRenderer'
import PTOCellRenderer from '../PTOCellRenderer'
import NameCellRenderer from '../NameCellRenderer'
import EmptyCellRenderer from '../EmptyCellRenderer'
import PermissionsCellRenderer from '../PermissionsCellRenderer'
import TeamScopeCellRenderer from '../TeamScopeCellRenderer'
import ManageScopeCellRenderer from '../ManageScopeCellRenderer'
import {canUserAccessManagerScopes, isPossibleToEditUserAssignments} from "../../../utils"
import BalanceRulesEditorDialogContent from '../../../../../controls/BalanceRulesEditorDialogContent'
import {arrayToSet} from '../../../../../atUtils'
import {getGenerateMoneyReportsRightTitle} from '../../../../../permissions/PermissionsUtils'

export const PUNCTUATORS = StringTokenizer.PUNCTUATORS_FOR_SEARCH;

class UserTableController extends Table {
    constructor({
            containerEl,
            tHeadEl,
            userBeans,
            canManageLeaveBalances,
            canManageAccounts,
            canManageScope,
            accountSettingsVisible,
            usersWithoutApprovers,
            ptoFeatureEnabled,
            sickFeatureEnabled,
            wasFeatureEnabled,
            ugrFeatureEnabled = false,
            sortOrder,
            handlersMap,
            ptoHoursPerDay,
            groupMap,
            timeZoneGroupMap,
            ptoDefaults,
            sickDefaults,
            generateMoneyReportsTitle = "",
        }) {

        super(tHeadEl, containerEl)

        this.containerEl = containerEl

        this.params = {
            containerEl,
            userBeans,
            canManageLeaveBalances,
            canManageAccounts,
            canManageScope,
            accountSettingsVisible,
            usersWithoutApprovers,
            ptoFeatureEnabled,
            sickFeatureEnabled,
            wasFeatureEnabled,
            ugrFeatureEnabled,
            sortOrder,
            handlersMap,
            ptoHoursPerDay,
            groupMap,
            timeZoneGroupMap,
            generateMoneyReportsTitle,
        }

        this.state = {
            showPTOTab: ptoFeatureEnabled && canManageLeaveBalances,
            showSDPTab: sickFeatureEnabled && canManageLeaveBalances,
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false,
            ptoDefaults: ptoDefaults,
            sickDefaults: sickDefaults
        }

        this.warningsController = new WarningsController();

        this.tableRenderer = new UserTableRenderer();
        this.tableRenderer.init();
        this.rowRenderer = new UserRowRenderer().init();

        this.userIdRowMap = {};

        this.tokensHighlighter = new EmptyHighlighter();

        if (ugrFeatureEnabled && groupMap !== null) {
            this.groupList = _.map(Object.keys(groupMap), (id) => {
                return {
                    id: Number(id),
                    name: groupMap[id]
                }
            })
        } else {
            this.groupList = []
        }

        this.$body = $('body')

        this._initializeFormatters()

        this._createPtoRuleManager(this.state.ptoDefaults, this.$body)

        this._createSickRulesManager(this.state.sickDefaults, this.$body)

        this.createBodyContent(userBeans, groupMap, timeZoneGroupMap, this.tokensHighlighter);

        this.onStatePropertyChanged('showPTOTab', (isPTOTabVisible) => {
            this._createPtoRuleManager(this.state.ptoDefaults, this.$body)
        })

        this.onStatePropertyChanged('showSDPTab', (showSDPTab) => {
            this._createSickRulesManager(this.state.sickDefaults, this.$body)
        })

        this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled', 'isTTAEnabled'], () => {
            this.params.generateMoneyReportsEnabled = this.state.isURAEnabled || this.state.isBTYEnabled;
            this.params.generateMoneyReportsTitle = getGenerateMoneyReportsRightTitle(this.state.isURAEnabled, this.state.isBTYEnabled)

            this.updatePermissionsColumn(this.state.isURAEnabled, this.state.isBTYEnabled)
            this.updateManageScopeColumn(this.state.isURAEnabled, this.state.isBTYEnabled)
            this.updateTeamsScopeColumn(this.state.isURAEnabled, this.state.isBTYEnabled)
        })
    }

    templateHtml() {
        return "<div></div>"
    }

    afterRender() {
        this.buildDOM(this.getEl())
    }

    makeUserIdGroupIdMapForVisibleUser() {
        const map = {};
        for (let i = 0; i < this.rows.length; i++) {
            const userListUserInfo = this.rows[i].getUserListUserInfo();
            map[userListUserInfo.id] = userListUserInfo.userGroupId;
        }
        return map;
    }

    makeTimeZoneIdGroupIdMapForVisibleUser() {
        const map = {};
        for (let i = 0; i < this.rows.length; i++) {
            const userListUserInfo = this.rows[i].getUserListUserInfo();
            map[userListUserInfo.id] = userListUserInfo.timeZoneGroupId;
        }
        return map;
    }

    getBaseRowClasses(rowIdx) {
        // TODO: When we get rid of the UserTableRow, this table has to keep array of UserListUserInfo structures.
        return this.rowRenderer.getRowClasses(this.getRow(rowIdx).getUserListUserInfo());
    }

    createBodyContent(userListUserInfoRecords, groupsMap, timeZoneGroupsMap, tokensHighlighter) {
        for (let i = 0; i < userListUserInfoRecords.length; i++) {
            const userListUserInfo = userListUserInfoRecords[i];
            const groupName = groupsMap === null ? "" : groupsMap[userListUserInfo.userGroupId];
            const timeZoneGroupName = timeZoneGroupsMap === null ? "" : timeZoneGroupsMap[userListUserInfo.timeZoneGroupId];

            this.addRow(this.createRow(userListUserInfo, groupName, timeZoneGroupName, tokensHighlighter, []));
        }
    }

    disableTextSelection() {
        //do not disable selection;
    }

    buildDOM(containerEl) {
        super.buildDOM(containerEl[0]);
        this.updateUI();
        this.tableRenderer.setupEventHandlers(this.params.handlersMap);
    }

    _findRow(e) {
        //this two rows for fix bug  51665 IE8
        const event = e || window.event;
        const targetElement = event.target || event.srcElement;
        return $(targetElement).closest('tr');
    }

    toggleHoverClassInPtoRulesCell(e, hovered) {
        this._findRow(e).toggleClass('ptoRulesCellHovered', hovered)
    }

    toggleHoverClassInSickDaysRulesCell(e, hovered) {
        this._findRow(e).toggleClass('sickDaysRulesCellHovered', hovered)
    }

    toggleHoverClassInPtoBalanceCell(e, hovered) {
        this._findRow(e).toggleClass('ptoBalanceCellHovered', hovered)
    }

    toggleHoverClassInSickDaysBalanceCell(e, hovered) {
        this._findRow(e).toggleClass('sickDaysBalanceCellHovered', hovered)
    }

    toggleHoverClassInPtoHistoryCell(e, hovered) {
        this._findRow(e).toggleClass('ptoHistoryCellHovered', hovered)
    }

    toggleHoverClassInSickDaysHistoryCell(e, hovered) {
        this._findRow(e).toggleClass('sickDaysHistoryCellHovered', hovered)
    }

    toggleHoverClassInPtoControlCell(e, hovered) {
        this._findRow(e).toggleClass('ptoControlCellHovered', hovered)
    }

    toggleHoverClassInSickDaysControlCell(e, hovered) {
        this._findRow(e).toggleClass('sickDaysControlCellHovered', hovered)
    }

    toggleHoverClassInNameCell(cell, hovered) {
        $(cell.getRow().getRowEl()).toggleClass('nameCellHovered', hovered)
    }

    toggleHoverClassInManageCell(cell, hovered) {
        $(cell.getRow().getRowEl()).toggleClass('manageCellHovered', hovered)
    }

    toggleHoverClassInTeamScopeCell(cell, hovered) {
        $(cell.getRow().getRowEl()).toggleClass('teamScopeCellHovered', hovered)
    }

    toggleHoverClassInManageScopeCell(cell, hovered) {
        $(cell.getRow().getRowEl()).toggleClass('manageScopeCellHovered', hovered)
    }

    _modifyPTOAccrualRules(cell) {
        const dialogValues = this.ptoRulesManager.getDialogValues();

        this.params.handlersMap.modifyPTOAccrualRules(cell, dialogValues, () => { this.ptoRulesManager.hideDialog(); });
    }

    _modifySickAccrualRules(cell) {
        const dialogValues = this.sickRulesManager.getDialogValues();

        this.params.handlersMap.modifySickAccrualRules(cell, dialogValues, () => { this.sickRulesManager.hideDialog(); });
    }

    _onEditRulesClicked(jQueryEvent, rulesManager, balanceData, cell, cellSelector, onClickCallback) {
        if (!balanceData)
            return;

        rulesManager.hideAccrualRulesTooltip();
        rulesManager.updateDialog(balanceData);

        const row = this._findRow(jQueryEvent);

        rulesManager.setModifyBalanceAccrualRulesOkClick(onClickCallback);

        rulesManager.setOnCloseCallback(() => {
            row.removeClass("ptoEditorSelected");
            this.clearRowSelection(row);
        })

        const event = jQueryEvent || window.event;
        let targetCell = event.target || event.srcElement;
        targetCell = !balanceData.defaultRules ? row.find(".resetRule:visible") : row.find(".defaultRule:visible");


        rulesManager.showDialogAt(targetCell, {offset: "5px -10px"});

        row.addClass("ptoEditorSelected");
        this.addRowSelection(row);
    }

    _onEditPTORulesClicked(jQueryEvent, balanceData, cell) {
        this._onEditRulesClicked(jQueryEvent, this.ptoRulesManager, balanceData, cell, ".ptoRulesCell", () => { this._modifyPTOAccrualRules(cell) })
    }

    _onEditSickRulesClicked(jQueryEvent, balanceData, cell) {
        this._onEditRulesClicked(jQueryEvent, this.sickRulesManager, balanceData, cell, ".sickRulesCell", () => { this._modifySickAccrualRules(cell) })
    }

    createRow(userListUserInfo, groupName, timeZoneGroupName, tokensHighlighter, warningsData) {
        const row = new UserTableRow().init(userListUserInfo);
        this.userIdRowMap[userListUserInfo.id] = row;

        const possibleToEditAccountSettings = this._isEditingUsersAllowed()
        const usersWithoutApproversSet = arrayToSet(this.params.usersWithoutApprovers)

        const nameCell = new UserNameCell().init(userListUserInfo, groupName, timeZoneGroupName, row, warningsData.warningMsgs, warningsData.infoMsgs);
        nameCell.setRenderer(new NameCellRenderer().init({
            tokensHighlighter: tokensHighlighter,
            isEditingAllowed: userListUserInfo.editable,
            hasApprover: !usersWithoutApproversSet[userListUserInfo.id],
            onClickCb: this._handleNameCellClick,
            warningsController: this.warningsController,
            onMouseIn: this._handleNameCellMouseIn,
            onMouseOut: this._handleNameCellMouseOut,
        }))

        row.addNameCellObj(nameCell)

        const spacerOne = new TableCell()
        spacerOne.setRenderer(new EmptyCellRenderer())
        row.addCellObj(spacerOne)

        const permissionsCell = new EditableCell().init(userListUserInfo, row)
        const permissionsCellRenderer = new PermissionsCellRenderer({
            editable: possibleToEditAccountSettings,
            generateMoneyReportsEnabled: this.state.isURAEnabled || this.state.isBTYEnabled,
            generateMoneyReportsTitle: this.params.generateMoneyReportsTitle,
            isTTAEnabled: this.params.isTTAEnabled,
            onClick: this._handlePermissionsCellClick,
            onMouseIn: this._handlePermissionsCellMouseIn,
            onMouseOut: this._handlePermissionsCellMouseOut
        })
        permissionsCell.setRenderer(permissionsCellRenderer)
        row.addPermissionsCellObj(permissionsCell)

        const teamScopeCell = new EditableCell().init(userListUserInfo, row)
        teamScopeCell.setRenderer(new TeamScopeCellRenderer({
            editable: possibleToEditAccountSettings,
            onClick: this._handleTeamScopeCellClick,
            onMouseIn: this._handleTeamScopeCellMouseIn,
            onMouseOut: this._handleTeamScopeCellMouseOut,
            isURAEnabled: this.state.isURAEnabled,
            isBTYEnabled: this.state.isBTYEnabled,
        }))
        row.addTeamScopeCellObj(teamScopeCell)

        const manageScopeCell = new EditableCell().init(userListUserInfo, row)
        manageScopeCell.setRenderer(new ManageScopeCellRenderer({
            editable: possibleToEditAccountSettings,
            onClick: this._handleManageScopeCellClick,
            onMouseIn: this._handleManageScopeCellMouseIn,
            onMouseOut: this._handleManageScopeCellMouseOut,
            isURAEnabled: this.state.isURAEnabled,
            isBTYEnabled: this.state.isBTYEnabled,
        }))
        row.addManageScopeCellObj(manageScopeCell)

        if (this.state.showPTOTab) {
            const ptoCell = new TableCell(userListUserInfo)
            ptoCell.setRenderer(new PTOCellRenderer().init(
                {
                    onClickHandler: this.params.handlersMap.editPTOBalance,
                    onMouseOverHandler: e => this.toggleHoverClassInPtoBalanceCell(e, true),
                    onMouseOutHandler: e => this.toggleHoverClassInPtoBalanceCell(e, false),
                },
                this.params.ptoHoursPerDay))
            row.addCellObj(ptoCell)
        }

        if (this.state.showSDPTab) {
            const sickDaysCell = new TableCell(userListUserInfo)
            sickDaysCell.setRenderer(new SickDaysCellRenderer().init(
                {
                    onClickHandler: this.params.handlersMap.editSickDaysBalance,
                    onMouseOverHandler: e => this.toggleHoverClassInSickDaysBalanceCell(e, true),
                    onMouseOutHandler: e => this.toggleHoverClassInSickDaysBalanceCell(e, false),
                },
                this.params.ptoHoursPerDay))
            row.addCellObj(sickDaysCell)
        }

        if (this.isShowHistoryAvailable()) {
            const showPtoHistoryCell = new TableCell(userListUserInfo)
            showPtoHistoryCell.setRenderer(new ShowPtoHistoryCellRenderer().init({
                onClickHandler: this.params.handlersMap.showPtoHistory,
                onMouseOverHandler: e => this.toggleHoverClassInPtoHistoryCell(e, true),
                onMouseOutHandler: e => this.toggleHoverClassInPtoHistoryCell(e, false),
            }))
            row.addCellObj(showPtoHistoryCell)

            const showSickDaysHistoryCell = new TableCell(userListUserInfo)
            showSickDaysHistoryCell.setRenderer(new ShowSickDaysHistoryCellRenderer().init({
                onClickHandler: this.params.handlersMap.showSickHistory,
                onMouseOverHandler: e => this.toggleHoverClassInSickDaysHistoryCell(e, true),
                onMouseOutHandler: e => this.toggleHoverClassInSickDaysHistoryCell(e, false),
            }))
            row.addCellObj(showSickDaysHistoryCell)
        }

        if (this.state.showPTOTab) {
            let handlers = {
                onMouseOverHandler: (e, ptoData) => {
                    this.toggleHoverClassInPtoRulesCell(e, true)
                    this.ptoRulesManager.showAccrualRulesTooltip(e, ptoData)
                },

                onMouseOutHandler: e => {
                    this.toggleHoverClassInPtoRulesCell(e, false)
                    this.ptoRulesManager.hideAccrualRulesTooltip()
                },

                onMouseMoveHandler: e => this.ptoRulesManager.moveAccrualRulesTooltip(e),

                onClickHandler: (e, ptoData, cell) => this._onEditPTORulesClicked(e, ptoData, cell)
            }

            const plannedPTOLeavesCell = new TableCell(userListUserInfo);
            plannedPTOLeavesCell.setRenderer(new PlannedPTOLeaveRenderer().init(this.ptoValueFormatter));
            row.addCellObj(plannedPTOLeavesCell);

            const ptoSpacerOne = new TableCell()
            ptoSpacerOne.setRenderer(new EmptyCellRenderer('ptoTab'))
            row.addCellObj(ptoSpacerOne)

            const ptoResetRulesCell = new TableCell(userListUserInfo);
            ptoResetRulesCell.setRenderer(new PtoResetRulesCell().init(this.ptoRulesFormatter, handlers));
            row.addCellObj(ptoResetRulesCell);

            const ptoAccrualRulesCell = new TableCell(userListUserInfo);
            ptoAccrualRulesCell.setRenderer(new PtoAccrualRulesCell().init(this.ptoRulesFormatter, handlers));
            row.addCellObj(ptoAccrualRulesCell);

            const ptoCapRulesCell = new TableCell(userListUserInfo);
            ptoCapRulesCell.setRenderer(new PtoCapRulesCell().init(this.ptoRulesFormatter, handlers));
            row.addCellObj(ptoCapRulesCell);

            const defaultRulesCell = new TableCell(userListUserInfo);
            defaultRulesCell.setRenderer(new PtoDefaultRulesCell().init(null, handlers));
            defaultRulesCell.setColspan(3);
            row.addCellObj(defaultRulesCell);

            const ptoSpacerTwo = new TableCell()
            ptoSpacerTwo.setRenderer(new EmptyCellRenderer('ptoTab'))
            row.addCellObj(ptoSpacerTwo)

            const ptoControl = new TableCell(userListUserInfo)
            ptoControl.setRenderer(new PtoControlRenderer().init({
                onClickHandler: this.params.handlersMap.togglePTOControlStatus,
                onMouseOverHandler: e => this.toggleHoverClassInPtoControlCell(e, true),
                onMouseOutHandler: e => this.toggleHoverClassInPtoControlCell(e, false),
            }))
            row.addCellObj(ptoControl)
        }

        if (this.state.showSDPTab) {
            let handlers = {
                onMouseOverHandler: (e, ptoData) => {
                    this.toggleHoverClassInSickDaysRulesCell(e, true)
                    this.sickRulesManager.showAccrualRulesTooltip(e, ptoData)
                },

                onMouseOutHandler: e => {
                    this.toggleHoverClassInSickDaysRulesCell(e, false)
                    this.sickRulesManager.hideAccrualRulesTooltip()
                },

                onMouseMoveHandler: e => this.sickRulesManager.moveAccrualRulesTooltip(e),

                onClickHandler: (e, sickData, cell) => this._onEditSickRulesClicked(e, sickData, cell)
            }

            const plannedSickLeavesCell = new TableCell(userListUserInfo);
            plannedSickLeavesCell.setRenderer(new PlannedSickLeaveRenderer().init(this.sickValueFormatter));
            row.addCellObj(plannedSickLeavesCell);

            const sickDaysSpacerOne = new TableCell()
            sickDaysSpacerOne.setRenderer(new EmptyCellRenderer('sickDaysTab'))
            row.addCellObj(sickDaysSpacerOne)

            const sickDaysResetRulesCell = new TableCell(userListUserInfo);
            sickDaysResetRulesCell.setRenderer(new SickDaysResetRulesCell().init(this.sickRulesFormatter, handlers));
            row.addCellObj(sickDaysResetRulesCell);

            const sickDaysAccrualRulesCell = new TableCell(userListUserInfo);
            sickDaysAccrualRulesCell.setRenderer(new SickDaysAccrualRulesCell().init(this.sickRulesFormatter, handlers));
            row.addCellObj(sickDaysAccrualRulesCell);

            const sickDaysCapRulesCell = new TableCell(userListUserInfo);
            sickDaysCapRulesCell.setRenderer(new SickDaysCapRulesCell().init(this.sickRulesFormatter, handlers));
            row.addCellObj(sickDaysCapRulesCell);

            const defaultSickDaysRulesCell = new TableCell(userListUserInfo);
            defaultSickDaysRulesCell.setRenderer(new SickDaysDefaultRulesCell().init(null, handlers));
            defaultSickDaysRulesCell.setColspan(3);
            row.addCellObj(defaultSickDaysRulesCell);

            const sickDaysSpacerTwo = new TableCell()
            sickDaysSpacerTwo.setRenderer(new EmptyCellRenderer('sickDaysTab'))
            row.addCellObj(sickDaysSpacerTwo)

            const sickDaysControl = new TableCell(userListUserInfo)
            sickDaysControl.setRenderer(new SickDaysControlRenderer().init({
                onClickHandler: this.params.handlersMap.toggleSickDaysControlStatus,
                onMouseOverHandler: e => this.toggleHoverClassInSickDaysControlCell(e, true),
                onMouseOutHandler: e => this.toggleHoverClassInSickDaysControlCell(e, false),
            }))
            row.addCellObj(sickDaysControl)
        }

        return row;
    }

    updatePermissionsColumn(isURAEnabled, isBTYEnabled) {
        for (let row of this.rows) {
            row.getPermissionsCell().getRenderer().setContentState({
                generateMoneyReportsEnabled: isURAEnabled || isBTYEnabled,
                generateMoneyReportsTooltip: getGenerateMoneyReportsRightTitle(isURAEnabled, isBTYEnabled),
            })
        }
    }

    updateManageScopeColumn(isURAEnabled, isBTYEnabled) {
        for (let row of this.rows) {
            let userInfo = row.getManageScopeCell().getValue()

            row.getManageScopeCell().getRenderer().update({
                isURAEnabled: isURAEnabled,
                isBTYEnabled: isBTYEnabled,
                hasManageScope: canUserAccessManagerScopes({userInfo, isURAEnabled, isBTYEnabled})
            })
        }
    }

    updateTeamsScopeColumn(isURAEnabled, isBTYEnabled) {
        for (let row of this.rows) {
            let userInfo = row.getTeamScopeCell().getValue()

            row.getTeamScopeCell().getRenderer().update({
                isURAEnabled: isURAEnabled,
                isBTYEnabled: isBTYEnabled,
                hasManageScope: canUserAccessManagerScopes({userInfo, isURAEnabled, isBTYEnabled})
            })
        }
    }

    setUserTableStateAndUpdateUI(
        userListBeans,
        groupsMap,
        timeZoneGroupMap,
        usersWithoutApprovers,
        viewerSettings,
        sortOrder,
        tokens,
        isPTOEnabled,
        ptoHoursPerDay)
    {
        const usersData = userListBeans
        this._updateParamsWithViewerSettings(viewerSettings)
        this.params.ptoFeatureEnabled = isPTOEnabled
        this.params.ptoHoursPerDay = ptoHoursPerDay
        this.params.sortOrder = sortOrder
        this.params.usersWithoutApprovers = usersWithoutApprovers

        this._createPtoRuleManager(this.state.ptoDefaults, this.$body)

        this._createSickRulesManager(this.state.sickDefaults, this.$body)

        this.deleteAllRowsFromModelAndDom();

        this.removeTrSpacers();

        this.tokensHighlighter = tokens && tokens.length > 0 ? new TokensHighlighter(tokens, PUNCTUATORS) : new EmptyHighlighter();
        if (this.ptoRulesManager)
            this.ptoRulesManager.reinitAccrualRulesControls(ptoHoursPerDay);

        if (this.sickRulesManager)
            this.sickRulesManager.reinitAccrualRulesControls(ptoHoursPerDay);
        this.createBodyContent(usersData, groupsMap, timeZoneGroupMap, this.tokensHighlighter);


        this.buildModelRowsDOM(this.tbody);
        this.updateUI();
    }

    addCreatedUser(userListUserInfo, groupName, timeZoneGroupName, warnings) {
        const row = this.createRow(userListUserInfo, groupName, timeZoneGroupName, this.tokensHighlighter, warnings);
        this._insertRowIntoFirstPosition(row);
    }

    updateUser(userListUserInfo, viewerSettings, groupName, timeZoneGroupName, warnings, isEditMyself, noHighlight) {
        this._updateParamsWithViewerSettings(viewerSettings)

        const row = this.userIdRowMap[userListUserInfo.id];
        if (!row) { // update only existing rows
            return
        }
        this._updateRow(userListUserInfo, groupName, timeZoneGroupName, row, warnings, noHighlight);
        if (isEditMyself) {
            const canManageLeaveBalancesChanged = this.params.canManageLeaveBalances !== userListUserInfo.hasManagePTOAndSickRight;
            this.params.canManageLeaveBalances = userListUserInfo.hasManagePTOAndSickRight;
            if (canManageLeaveBalancesChanged)
                this.updateUI();
        }

        PageOverlayTipsManager.getInstance().refreshDynamicTips();
    }

    deleteUser(userId) {
        const row = $(this.userIdRowMap[userId].rowEl);
        const resetFirst = row.hasClass("first") && row.hasClass("newUser");

        this.removeRow(this.userIdRowMap[userId].getRowIdx());

        const newUsers = $(super.getTableEl()).find(".newUser");
        if (!newUsers.length)
            this.removeTrSpacers();
        else
            newUsers.first().addClass("first");

        PageOverlayTipsManager.getInstance().refreshDynamicTips();
    }

    highlightRow(row) {
        $(row.getRowEl()).addClass("updatedUser");
        setTimeout(() => {
            $(row.getRowEl()).removeClass('updatedUser');
        }, 1500)
    }

    _updateRow(userListUserInfo, groupName, timeZoneGroupName, row, warnings, noHighlight) {
        const newRow = this.createRow(userListUserInfo, groupName, timeZoneGroupName, this.tokensHighlighter, warnings);
        this.replaceRowAndUpdateDOM(row.getRowIdx(), newRow);

        const classesToCopy = ["newUser", "first", "last", "selected"];
        for (let i = 0; i < classesToCopy.length; i++) {
            if ($(row.getRowEl()).hasClass(classesToCopy[i]))
                $(newRow.getRowEl()).addClass(classesToCopy[i]);
        }

        if (!noHighlight) {
            this.highlightRow(newRow);
        }
    }

    removeTrSpacers() {
        $(".topSpacer, .bottomSpacer").remove();
    }

    _insertRowIntoFirstPosition(row) {
        this.setupRow(0, row);
        this.rows.unshift(row);
        for (let i = 1; i < this.rows.length; i++) {
            const nextRow = this.rows[i];
            nextRow.setRowIdx(i);
        }

        const rowElClasses = this.getRowElClasses(0);

        if (!$(super.getTableEl()).find('.newUser').length) {
            this.tbody.insertBefore(row.getRowEl(), this.tbody.firstChild);

            rowElClasses.push("last");
        } else {
            const firstNewUserEl = $(super.getTableEl()).find(".newUser.first")[0];
            this.tbody.insertBefore(row.getRowEl(), firstNewUserEl);
            $(super.getTableEl()).find(".newUser.first").removeClass("first");
        }

        row.writeCellsContent();
        rowElClasses.push("newUser");
        rowElClasses.push("first");
        row.getRowEl().className = rowElClasses.join(" ");
    }

    updateUserGroups(userIdGroupIdMap, groupMap) {
        for (let i = 0; i < this.rows.length; i++) {
            const row = this.rows[i];

            row.userListUserInfo.userGroupId = userIdGroupIdMap[row.userListUserInfo.id];

            const cell = row.getNameCell();
            const name = groupMap[row.userListUserInfo.userGroupId];

            //if user was concurrently deleted he isn't in userGroupMap but we do not react
            if (name)
                cell.updateGroupName(name);
        }
    }

    updateTimeZoneGroups(timeZoneIdGroupIdMap, timeZoneGroupsMap) {
        for (let i = 0; i < this.rows.length; i++) {
            const row = this.rows[i];

            row.userListUserInfo.timeZoneGroupId = timeZoneIdGroupIdMap[row.userListUserInfo.id];

            const cell = row.getNameCell();
            const name = timeZoneGroupsMap[row.userListUserInfo.timeZoneGroupId];

            if (name)
                cell.updateTimeZoneGroupName(name);
        }
    }

    updateUsersWithoutApprovers(usersWithoutApprovers) {
        this.params.usersWithoutApprovers = usersWithoutApprovers

        const usersWithoutApproversSet = arrayToSet(usersWithoutApprovers)
        this.rows.forEach((row) => {
            const cell = row.getNameCell();
            cell.getRenderer().updateUsersWithoutApproval(cell, !usersWithoutApproversSet[cell.getValue().id])
        })
    }

    setUsersAutoapproved() {
        this.rows.forEach((row) => {
            const cell = row.getNameCell()
            cell.setValue({...cell.getValue(), requiresTTApproval: false})
            cell.updateCell()
        })
    }

    addRowSelection(row) {
        row.addClass("selected");
    }

    addRowSelectionByIdx(idx) {
        const row = this.rows[idx]
        if (row) {
            this.addRowSelection($(row.getRowEl()))
        }
    }

    addRowSelectionByUserId(userId) {
        const row = this.rows.find((row) => {
            return row.userListUserInfo.id === userId
        })
        if (row) {
            this.addRowSelection($(row.getRowEl()))
        }
    }

    clearRowSelectionByUserId(userId) {
        const row = this.rows.find((row) => {
            return row.userListUserInfo.id === userId
        })
        if (row) {
            this.clearRowSelection($(row.getRowEl()))
        }
    }

    clearRowSelectionByIdx(idx) {
        const row = this.rows[idx]
        if (row) {
            this.clearRowSelection($(row.getRowEl()))
        }
    }

    clearRowSelection(row) {
        row.removeClass("selected");
    }

    showLoadingHistoryProgress(cell, spinner) {
        cell.addClass("loading");
        spinner.spinInElement($(cell.find(".ptoHistorySpinnerPlaceholder").get(0)));
    }

    hideLoadingHistoryProgress(cell, spinner) {
        cell.removeClass("loading");
        spinner.stop();
    }

    updateUI() {
        this.tableRenderer.updateUI(
            this,
            this._isEditingUsersAllowed(),
            (this.params.ptoFeatureEnabled || this.params.sickFeatureEnabled) && this.params.canManageLeaveBalances,
            this.params.ptoFeatureEnabled,
            this.params.sickFeatureEnabled,
            this.params.accountSettingsVisible,
            this.params.sortOrder.order,
            this.params.sortOrder.asc
        )
    }

    _updateParamsWithViewerSettings(viewerSettings) {
        this.params.canManageLeaveBalances = viewerSettings.allowedToManageLeaveBalanceSettings
        this.params.canManageAccounts = viewerSettings.allowedToManageAccountSettings
        this.params.accountSettingsVisible = viewerSettings.showAccountSettings
    }

    isManageLeaveBalancesColumnAvailable() {
        return (this.params.ptoFeatureEnabled || this.params.sickFeatureEnabled) && this.params.accountSettingsVisible
    }

    isShowHistoryAvailable() {
        return this.params.canManageLeaveBalances
    }

    _initializeFormatters() {
        const ptoPrecision = window.SystemSettings.showPTOInHours ? 2 : 1;
        const postfixPTOSymbol = window.SystemSettings.showPTOInHours
            ? messageResource.getMessage('common.pto_units.hours.short')
            : messageResource.getMessage('common.pto_units.days.short');

        this.ptoFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, ptoPrecision,
            true, '', postfixPTOSymbol);

        this.rulesFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, ptoPrecision,
            true, '', postfixPTOSymbol);

        const sickPrecision = window.SystemSettings.showSickInHours ? 2 : 1;
        const postfixSickSymbol = window.SystemSettings.showSickInHours
            ? messageResource.getMessage('common.pto_units.hours.short')
            : messageResource.getMessage('common.pto_units.days.short');

        this.sickFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, sickPrecision,
            true, '', postfixSickSymbol);

        this.sickDaysRulesFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, sickPrecision,
            true, '', postfixSickSymbol);

        this.ptoValueFormatter = (value) => {
            const val = window.SystemSettings.showPTOInHours ? value * this.params.ptoHoursPerDay : value;
            return this.ptoFormatter.format(val);
        };

        this.ptoRulesFormatter = (value) => {
            const val = window.SystemSettings.showPTOInHours ? value * this.params.ptoHoursPerDay : value;
            return this.rulesFormatter.format(val);
        };

        this.sickValueFormatter = (value) => {
            const val = window.SystemSettings.showSickInHours ? value * this.params.ptoHoursPerDay : value;
            return this.sickFormatter.format(val);
        };

        this.sickRulesFormatter = (value) => {
            const val = window.SystemSettings.showSickInHours ? value * this.params.ptoHoursPerDay : value;
            return this.sickDaysRulesFormatter.format(val);
        };
    }

    _createSickRulesManager(sickDefaults, $body) {
        if(this.state.showSDPTab && sickDefaults) {
            this.sickRulesManager && this.sickRulesManager.getEl().remove()
            this.sickRulesManager = new BalanceRulesEditorDialogContent({
                leaveBalanceTypePrefix: "sick",
                balanceDefaults: sickDefaults,
                countHoursPerDay: this.params.ptoHoursPerDay,
                parameters: {
                    defaultMessageNoteKey: "sick_rules_editor.info.default",
                    titleNoteKey: "sick_rules_editor.use_accrual_rules",
                    customMessageNoteKey: "pto_rules_editor.info.custom",
                    customTitleTooltip: "sick_rules_editor.custom_rules",
                    defaultTitleTooltip: "sick_rules_editor.default_rules"
                }
            }).init($body)
        }
    }

    _createPtoRuleManager(ptoDefaults, $body) {
        if(this.state.showPTOTab && ptoDefaults) {
            this.ptoRulesManager && this.ptoRulesManager.getEl().remove()
            this.ptoRulesManager = new BalanceRulesEditorDialogContent({
                leaveBalanceTypePrefix: "pto",
                balanceDefaults: ptoDefaults,
                countHoursPerDay: this.params.ptoHoursPerDay,
                parameters: {
                    defaultMessageNoteKey: "pto_rules_editor.info.default",
                    titleNoteKey: "pto_rules_editor.use_accrual_rules",
                    customMessageNoteKey: "pto_rules_editor.info.custom",
                    customTitleTooltip: "pto_rules_editor.custom_rules",
                    defaultTitleTooltip: "pto_rules_editor.default_rules"
                }
            }).init($body)
        }
    }

    _isEditingUsersAllowed() {
        return this.params.canManageAccounts
    }

    _getNameForTooltips(cell) {
        return cell.getValue().firstName
    }

    /* name cell */
    _handleNameCellClick = (cell, e) => {
        this.params.handlersMap.editUserAccountSettings(cell, e)
    }

    _handleNameCellMouseIn = (cell, e) => {
        this.toggleHoverClassInNameCell(cell, true)
    }

    _handleNameCellMouseOut = (cell, e) => {
        this.toggleHoverClassInNameCell(cell, false)
    }

    /* management cells */
    _handlePermissionsCellClick = (cell, e) => {
        if (this._isEditingUsersAllowed() && !cell.value.locked) {
            this.params.handlersMap.editUserPermissions(cell, e)
        }
    }

    _handlePermissionsCellMouseIn = (cell, e) => {
        if (this._isEditingUsersAllowed()) {
            this.toggleHoverClassInManageCell(cell, true)
        }
    }

    _handlePermissionsCellMouseOut = (cell, e) => {
        if (this._isEditingUsersAllowed()) {
            this.toggleHoverClassInManageCell(cell, false)
        }
    }

    _handleTeamScopeCellClick = (cell, e) => {
        if (this._isEditingUsersAllowed() && isPossibleToEditUserAssignments({
                userInfo: cell.getValue(),
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            })
        ) {
            this.params.handlersMap.editTeamAssignmentsPermissions(cell, e)
        }
    }

    _handleTeamScopeCellMouseIn = (cell, e) => {
        if (this._isEditingUsersAllowed() && isPossibleToEditUserAssignments({
                userInfo: cell.getValue(),
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            })
        ) {
            this.toggleHoverClassInTeamScopeCell(cell, true)
        }
    }

    _handleTeamScopeCellMouseOut = (cell, e) => {
        if (this._isEditingUsersAllowed() && isPossibleToEditUserAssignments({
                userInfo: cell.getValue(),
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            })
        ) {
            this.toggleHoverClassInTeamScopeCell(cell, false)
        }
    }

    _handleManageScopeCellClick = (cell, e) => {
        if (this._isEditingUsersAllowed() && isPossibleToEditUserAssignments({
                userInfo: cell.getValue(),
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            })
        ) {
            this.params.handlersMap.editManagementAssignmentsPermissions(cell, e)
        }
    }

    _handleManageScopeCellMouseIn = (cell, e) => {
        if (this._isEditingUsersAllowed() && isPossibleToEditUserAssignments({
                userInfo: cell.getValue(),
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            })
        ) {
            this.toggleHoverClassInManageScopeCell(cell, true)
        }
    }

    _handleManageScopeCellMouseOut = (cell, e) => {
        if (this._isEditingUsersAllowed() && isPossibleToEditUserAssignments({
                userInfo: cell.getValue(),
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled
            })
        ) {
            this.toggleHoverClassInManageScopeCell(cell, false)
        }
    }

}

export default connect(
    (state) => ({
        showPTOTab: isPTOTabAvailable(state),
        showSDPTab: isSDBTabAvailable(state),
        isBTYEnabled: isBTYEnabled(state),
        isURAEnabled: isURAEnabled(state),
        isTTAEnabled: isTTAEnabled(state),
    })
)(UserTableController)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/userTable/UserTableController.js